<button class="top-navi" routerLink="/account" mat-button><mat-icon>arrow_back</mat-icon>Zurück zur Praxisseite</button>
<mat-card class="card">
  <mat-card-content>
    <h1>Datenzugriff Test</h1>
    <input class="input" #officeInput type="text" />
    <div class="buttons">
      <button mat-raised-button color="primary" (click)="loadOfficeDate(officeInput.value)">
        Lade Daten der Praxis
      </button>
    </div>

    <p>
      {{ testResult | json }}
    </p>
  </mat-card-content>
</mat-card>
